// TODO: remove when cleaning up remove-issueviewinteractivequery-m1
export const getJiraSettingsQuery = () => `
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;
